<template>
  <div card-add>
    <MercenaryHeader :title="'결제수단 추가'" :back-title="'활동 및 설정'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>

    <div class="card-wrap">
      <div>
        <div class="logos" style="margin-top:20px;">
          <div style="display:flex; align-items: center;">
            <span class="title">카드번호</span>
            <img style="width: 28px; margin-left:10px; vertical-align: bottom;" src="@/assets/images/mypage/ico-visa.png" alt="">
            <img style="width: 20px; margin-left:5px; vertical-align: bottom;" src="@/assets/images/mypage/ico-card-xs.png" alt="">
            <img style="width: 35px; margin-left:5px; vertical-align: bottom;" src="@/assets/images/mypage/ico-amex.png" alt="">
          </div>
        </div>
        <div>
          <div class="row_wrap">
            <div style="height:48px; display:flex; align-items: center; background-color: #f5f5f5; border-radius:12px; padding:0px 12px; padding-left: 4px;">
              <input type="tel" class="card_num_input" placeholder="0000" v-model="card_number1" style="display:inline-block;text-align:center;width:50px;" maxlength="4" ref="card_number1" @keyup="goNext($event, null, 2)" @click="select($event)">
              <div style="display:inline-block;">-</div>
              <input type="tel" class="card_num_input" placeholder="0000" v-model="card_number2" style="display:inline-block;text-align:center;width:50px;" maxlength="4" ref="card_number2" @keyup="goNext($event, 1, 3)" @click="select($event)">
              <div style="display:inline-block;">-</div>
              <input type="tel" class="card_num_input custom-password" placeholder="0000" v-model="card_number3" style="display:inline-block;text-align:center;-webkit-text-security:disc;" :style="{ width: card_number_input_width }" maxlength="4" ref="card_number3" @keyup="goNext($event, 2, 4)" @click="select($event)">
              <div style="display:inline-block;">-</div>
              <input type="tel" class="card_num_input custom-password" placeholder="0000" v-model="card_number4" style="display:inline-block;text-align:center;-webkit-text-security:disc;" :style="{ width: card_number_input_width }" maxlength="4" ref="card_number4" @keyup="goNext($event, 3, null)" @click="select($event)">
            </div>
          </div>

          <div class="row_wrap" style="display:flex;gap: 20px;">
            <div style="flex:1;">
              <div class="title">만료일</div>
              <input class="info_input" type="tel" placeholder="월(MM) / 연도(YY)" v-model="mmyy" maxlength="5" style="" ref="mmyy_input">
            </div>
            <div style="flex:1;">
              <div class="title">생년월일</div>
              <input class="info_input" type="tel" placeholder="901107" v-model="birthday" maxlength="6" style="">
            </div>
          </div>

          <div class="row_wrap">
            <div>
              <div class="title">비밀번호 앞2자리</div>
              <input class="info_input" type="password" placeholder="" maxlength="2" v-model="card_password" style="">
            </div>
          </div>

        </div>
      </div>
    </div>
    <div style="flex: 1;"></div>
    <div style="padding:12px;">
      <a @click="savePayMethods" style="display:grid; place-items: center; background-color: black; color:white; height:48px; border-radius:12px;">완료</a>
    </div>

  </div>
</template>

<script>
import ResponseCode from "../../../ResponseCode";
import Util from "../../../modules/util";
import MercenaryHeader from "../../common/MercenaryHeader";

export default {
  name: "CardAdd",
  components: { MercenaryHeader },
  props: {
    completeAction: {
      type: Function,
      default: () => { }
    }
  },
  data() {
    return {
      card_number: '',
      card_number1: '',
      card_number2: '',
      card_number3: '',
      card_number4: '',
      birthday: '',
      mmyy: '',
      card_password: '',
      card_number_origin: '',
      card_number_input_width: '52px'
    }
  },
  methods: {
    select(e) {
      const target = e.currentTarget;
      target.focus();
      target.select();
    },
    back() {
      this.$GlobalStore.closeLastModal()
    },
    async savePayMethods() {
      this.card_number = this.card_number1 + '-' + this.card_number2 + '-' + this.card_number3 + '-' + this.card_number4;

      if (this.card_number.length !== 19) {
        this.$GlobalStore.showAlert('카드번호를 입력해주세요.');
        return;
      }

      if (this.birthday.length !== 6) {
        this.$GlobalStore.showAlert('생년월일 앞 6자리를 입력해주세요.');
        return;
      }

      if (this.mmyy.length !== 5) {
        this.$GlobalStore.showAlert('만료일을 입력해주세요.');
        return;
      }

      if (this.card_password.length !== 2) {
        this.$GlobalStore.showAlert('비밀번호 앞 2자리를 입력해주세요.');
        return;
      }

      const parameters = {};
      parameters.card_number = this.card_number;
      parameters.birthday = this.birthday;
      parameters.mmyy = this.mmyy;
      parameters.card_password = this.card_password;

      const res = await this.$Axios.post('/api/paymethod/save', parameters);
      if (res.data.code === ResponseCode.SUCCESS) {
        this.completeAction();
        this.$GlobalStore.closeLastModal();
      } else {
        this.$GlobalStore.showAlert(res.data.msg);
      }
    },
    goNext(e, prevIndex, nextIndex) {
      const el = e.currentTarget;
      const cur_value_length = el.value.length
      if (cur_value_length === 0) {
        if (prevIndex) this.$refs['card_number' + prevIndex].focus();
      } else if (cur_value_length === 4) {
        if (nextIndex) this.$refs['card_number' + nextIndex].focus();
      }
    }
  },
  mounted() {
    // Util.setCardNumberFormmater(this.$refs.card_number_input);
    Util.setCardMMYYFormmater(this.$refs.mmyy_input);
  },
  created() {
    // this.$GlobalStore.showAlert('업데이트 준비중입니다.');
    // this.$GlobalStore.closeLastModal();

    this.savePayMethods = this.$Once(this.savePayMethods);
    //
    // if(this.$cookies.get('device') === 'ios'){
    //   this.card_number_input_width = '65px';
    // }
  }
}
</script>

<style scoped>
.custom-password {
  font-family: 'Password';
  font-size: 24px;
  height: 30px;
  padding-top: 5px;
  /* 원하는 크기로 설정 */
}

/* Custom font for password dots */
@font-face {
  font-family: 'Password';
  src: local('Arial');
  unicode-range: U+0020-007E;
}

.custom-password::placeholder {
  font-family: 'Password';
}

.title {
  color: #210F03;
  font-size: 14px;
  margin-bottom: 3px;
}

.card_num_input {
  border: 0px;
  background-color: #f5f5f5;
  color: #210F03;
  outline: none;
  font-size: 16px;
}

.card_num_input::placeholder {
  color: #BBBBBB;
  font-size: 16px;
}

.card-wrap {
  padding: 12px;
}

.info_input {
  width: 100%;
  border: 0px;
  background-color: #f5f5f5;
  color: #210F03;
  outline: none;
  font-size: 16px;
  height: 48px;
  padding: 0px 12px;
  border-radius: 12px;
}

.info_input::placeholder {
  color: #BBBBBB;
  font-size: 16px;
}

.row_wrap {}

.row_wrap+.row_wrap {
  margin-top: 10px;
}
</style>